"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = ['==', '!=', '=~', '!~', '=i=',
/*
 * The following comparators include a space, it is _important_ that this space is here.
 * Note that this defines the "default" usage of comparators to be UNSPACED
 */
' isEmpty', ' isNotEmpty', ' isSet', ' isNotSet', ' isNull', ' isNotNull'];